import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  STORE_BUYER_FETCH_SELLERS,
  STORE_STATUS_INITIALIZED,
  STORE_BUYER,
} from 'constants/store'
import { ErrorStore, CreditLimitResponse, CreditLimitStatusEnum } from '@types'
import {
  createGenericSlice,
  GenericState,
  createReducers,
  ExtraReducers,
} from 'stores/generics'
import { Payload } from 'stores'

export type CreditLimitState = CreditLimitResponse

type State = GenericState<CreditLimitState>

export const initialState: State = {
  data: {
    available_limit_cents: 0,
    used_limit_cents: 0,
    displayed_limit_cents: 0,
    status: CreditLimitStatusEnum.Undefined,
  },
  status: STORE_STATUS_INITIALIZED,
  error: null,
}

export const fetchCreditLimit = createAsyncThunk<
  CreditLimitState,
  Promise<CreditLimitResponse>,
  Payload
>(
  STORE_BUYER_FETCH_SELLERS,
  async (promise: Promise<CreditLimitResponse>, { rejectWithValue }) => {
    try {
      const response = await promise
      return response
    } catch (e: unknown) {
      const { code, message } = e as ErrorStore
      return rejectWithValue({ code, message })
    }
  }
)

const extraReducers: ExtraReducers = createReducers<
  CreditLimitState,
  CreditLimitResponse,
  Payload
>(fetchCreditLimit, initialState.data)

const userSlice = createGenericSlice({
  name: STORE_BUYER,
  initialState,
  reducers: {},
  extraReducers,
})

const { actions, reducer } = userSlice

const { clear } = actions

export { clear }

export default reducer
